import { ReactComponent as IconClose } from "@/assets/svgs/icon-close.svg";
import { ReactComponent as IconDelete } from "@/assets/svgs/info.svg";
import Button from "@/components/Button/index";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from "@/utils/rem";
import React from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmDeclineModal({
	isVisible,
	cancel,
	confirm,
	title,
	packageName,
}) {
	const { t } = useTranslation();
	const [message, setMessage] = React.useState("");

	return (
		<Modal visible={isVisible} variant="medium" close={cancel}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconDelete />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										{title}
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div
							style={{
								fontSize: rem(16),
								textAlign: "center",
								marginBottom: rem(24),
							}}
						>
							Are you sure want to decline the sharing of{" "}
							<b>{packageName}</b>
						</div>
						<div
							className="flex-center"
							style={{
								justifyContent: "center",
							}}
						>
							<textarea
								style={{
									maxWidth: rem(365),
								}}
								onChange={(e) => {
									setMessage(e.target.value);
								}}
								placeholder="Reason for declining (Optional)"
								rows="5"
							></textarea>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={cancel} />
						<span
							style={{ width: rem(10), display: "inline-block" }}
						></span>

						<Button
							text="Confirm"
							submit={(e) => {
								e.preventDefault();
								e.stopPropagation();
								confirm(message);
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	);
}
